<template>
  <div class="space-between">
    <v-btn
      v-if="!icon"
      small
      ripple
      :color="defaultColor"
      v-bind="$attrs"
      @click="emit()"
    >
      {{ defaultText }}
    </v-btn>
    <v-btn v-else v-bind="$attrs" flat icon :color="defaultColor">
      <v-icon class="icon material-icons" @click="emit()">
        {{ defaultText }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'MetaButton',
  props: {
    type: {
      type: String,
      require: true,
      validator: (value) => {
        if (!value) {
          return false
        }
        return (
          [
            'clone',
            'new',
            'add',
            'reset',
            'save',
            'update',
            'edit',
            'delete',
            'create',
            'finalize',
            'recover',
            'cancel',
          ].indexOf(value) !== -1
        )
      },
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    full: {
      type: Boolean,
      required: false,
      default: false,
    },
    timeout: {
      type: [Number, String],
      required: false,
      default: 1000,
    },
    icon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    defaultText() {
      if (this.icon) {
        switch (this.type) {
          case 'update':
            return 'create'
          case 'delete':
            return 'delete'
          case 'create':
          case 'add':
            return 'add'
          case 'clone':
            return 'file_copy'
          default:
            return 'none'
        }
      }
      if (this.text) {
        return this.text
      }
      switch (this.type) {
        case 'new':
          return this.$t('action.buttons.new')
        case 'add':
          return this.$t('action.buttons.add')
        case 'reset':
          return this.$t('action.buttons.reset')
        case 'create':
          return this.$t('action.buttons.create')
        case 'update':
          return this.$t('action.buttons.update')
        case 'delete':
          return this.$t('action.buttons.delete')
        case 'cancel':
          return this.$t('action.buttons.cancel')
        case 'clone':
          return this.$t('action.buttons.clone')
        case 'save':
          return this.$t('action.buttons.save')
      }
      return ''
    },
    defaultColor() {
      if (this.icon) {
        switch (this.type) {
          case 'update':
            return 'success'
          case 'delete':
            return 'error'
          case 'create':
          case 'add':
          case 'clone':
          case 'save':
            return 'primary'
          default:
            return 'none'
        }
      }
      switch (this.type) {
        case 'new':
        case 'add':
          return 'primary'
        case 'reset':
          return 'warning'
        case 'create':
          return 'success'
        case 'update':
          return 'secondary'
        case 'delete':
          return 'error'
        case 'cancel':
        case 'clone':
        case 'save':
          return 'primary'
      }
      return ''
    },
  },
  methods: {
    emit() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped lang="scss">
.space-between {
  margin-left: 5px;
  margin-right: 5px;
}
</style>
